import { render, staticRenderFns } from "./RemovePlan.vue?vue&type=template&id=51bd92fe&scoped=true"
import script from "./RemovePlan.vue?vue&type=script&lang=js"
export * from "./RemovePlan.vue?vue&type=script&lang=js"
import style0 from "./RemovePlan.vue?vue&type=style&index=0&id=51bd92fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bd92fe",
  null
  
)

export default component.exports